import { useFetchTremendousOptions } from '@/features/wallet/api'
import { TremendousOptionsBrowser } from '@/features/wallet/components/TremendousOptionsBrowser'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/ui-kit/components/Dialog'
import { Drawer, DrawerClose, DrawerContent, DrawerHeader, DrawerTitle } from '@/ui-kit/components/Drawer'
import { SCREEN_SIZE, useMediaQuery } from '@/ui-kit/media'
import { Trans, useLingui } from '@lingui/react/macro'
import { X } from 'lucide-react'
import { useState } from 'react'

type TremendousOptionsLinkProps = {
  minPayout: number
  maxAmountUsd: number | undefined
}

// The only options observer: mounting with the selected Tremendous method starts the fill, and the
// browser reads this query instead of opening a second observer.
export const TremendousOptionsLink = ({ minPayout, maxAmountUsd }: TremendousOptionsLinkProps) => {
  const { t } = useLingui()
  const query = useFetchTremendousOptions()
  const [open, setOpen] = useState(false)
  const isMobile = useMediaQuery(SCREEN_SIZE.MOBILE)

  const browser = <TremendousOptionsBrowser query={query} minPayout={minPayout} maxAmountUsd={maxAmountUsd} />

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="text-body-3 text-orange -mt-3 self-start underline"
      >
        <Trans>See options for your country</Trans>
      </button>

      {isMobile ? (
        <Drawer open={open} onOpenChange={setOpen}>
          <DrawerContent className="max-h-[85vh]">
            <DrawerHeader className="flex flex-row items-center justify-between gap-3 border-b border-solid border-gray-100 px-4 py-3">
              <DrawerTitle className="text-body-2 text-gray-90">
                <Trans>Tremendous options by country</Trans>
              </DrawerTitle>
              <DrawerClose
                aria-label={t`Close`}
                className="text-gray-80 hover:text-gray-70 -m-2 flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg transition-colors"
              >
                <X className="size-5" />
              </DrawerClose>
            </DrawerHeader>
            <div className="min-h-0 flex-1 overflow-y-auto p-4 pb-6">{browser}</div>
          </DrawerContent>
        </Drawer>
      ) : (
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogContent className="max-w-[480px]!">
            <DialogHeader>
              <DialogTitle>
                <Trans>Tremendous options by country</Trans>
              </DialogTitle>
            </DialogHeader>
            {browser}
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}
